import * as React from 'react';
import { SlideUpPanel } from 'mobile-ui/components/slideup-panel';
import { PanelHeader, CloseButton, PanelBody } from 'components';
import { routes } from 'routes';
import { FavoritesList } from 'scenes/favourites-window/favorites-list';

import './style.scss';

export interface IMobileUIFavoritesWindowProps {}
export interface IMobileUIFavoritesWindowState {}

/* eslint-disable @typescript-eslint/indent */
class MobileUIFavoritesWindowComponent extends React.Component<
    IMobileUIFavoritesWindowProps,
    IMobileUIFavoritesWindowState
> {
/* eslint-enable @typescript-eslint/indent */

    constructor(props: IMobileUIFavoritesWindowProps) {
        super(props);
    }

    render() {
        return (
            <SlideUpPanel
                open
                className='mobile-ui-favorites fix-close-button'
            >
                <PanelHeader>
                    <CloseButton
                        onClick={() => {
                            routes.goBack(routes.map, { container: 'root' });
                        }}
                    />
                </PanelHeader>

                <PanelBody>
                    <FavoritesList
                        compareDisabled
                        onObjectFit={() => {
                            routes.goBack(routes.map, { container: 'root' });
                        }}
                    />
                </PanelBody>
            </SlideUpPanel>
        );
    }
}

export const MobileUIFavoritesWindow = MobileUIFavoritesWindowComponent;
